export const GA_EVENTS = {
    failedFetchError: 'Well guide status API fetch failed - Error',
    failedFetchUnauthorized: 'Well guide status API fetch failed - Unauthorized',
    failedParseResponse: 'Failed to parse well guide status API response',
    fetchingWellGuideStatus: 'Fetching well guide status API data',
    fetchedWellGuideStatus: 'Well guide status data fetched successfully',
};
